import { createReducer, on } from '@ngrx/store';
import { RequestStatus } from '../../enums/request-status.enum';
import * as UserActions from './user.actions';
import { User } from '../models/user.model';

export interface UserState {
  data: User | null;
  userStatus: RequestStatus;
  userError: string | null;
}

const initialState: UserState = {
  data: null,
  userStatus: RequestStatus.Idle,
  userError: null,
};

export const userReducer = createReducer(
  initialState,

  on(UserActions.loadUser, (state) => ({
    ...state,
    userStatus: RequestStatus.Loading,
    userError: null,
  })),

  on(UserActions.loadUserSuccess, (state, { user }) => ({
    ...state,
    data: user,
    userStatus: RequestStatus.Success,
    userError: null,
  })),

  on(UserActions.loadUserFailure, (state, { error }) => ({
    ...state,
    userStatus: RequestStatus.Error,
    userError: error,
  }))
);

